module.exports = __webpack_public_path__ + "img/select_branch.bf920d66.png";